import firebase from '../../firebase/index';

export const AUTH_USER = 'AUTH_USER';
export const LOGOUT = 'LOGOUT';
export const AUTH_UNCONFIMED = 'AUTH_UNCONFIMED';
export const AUTH_PENDING = 'AUTH_PENDING';

export function setUser(user) {
	return {
		type: AUTH_USER,
		user
	};
}

export function setAuthUnconfirmed() {
	return {
		type: AUTH_UNCONFIMED
	};
}

export function setAuthPending(state) {
	return {
		type: AUTH_PENDING,
		authPending: !!state
	};
}

export const logout = () => dispatch => firebase.auth()
	.signOut()
	.then(dispatch({type: LOGOUT}));



// WEBPACK FOOTER //
// ./src/client/redux/actions/auth.js